module.exports = __webpack_public_path__ + "static/media/heating-light-gray.ad2a20b9.svg";